import BroadcastChannel from 'broadcast-channel';
import { canUseDom } from 'exenv';
var w;
if (canUseDom) {
    w = window;
}
else {
    w = {};
}
var Channel;
if (!w.Channel) {
    if (w && w.BroadcastChannel) {
        Channel = w.BroadcastChannel;
    }
    else {
        var BroadCastProxy = /** @class */ (function () {
            function BroadCastProxy(name) {
                var _this = this;
                try {
                    this.parent = new BroadcastChannel(name);
                    this.parent.onmessage = function (event) {
                        if (_this.onmessage) {
                            _this.onmessage({ data: event });
                        }
                    };
                }
                catch (e) {
                    console.error(e);
                }
            }
            BroadCastProxy.prototype.postMessage = function (event) {
                try {
                    return this.parent.postMessage(event);
                }
                catch (e) {
                    console.error(e);
                    return false;
                }
            };
            return BroadCastProxy;
        }());
        Channel = BroadCastProxy;
    }
    w.Channel = Channel;
}
else {
    Channel = w.Channel;
}
export { Channel };
